import type { FontFamilyOptions as TiptapFontFamilyOptions } from '@tiptap/extension-font-family'
import { FontFamily as TiptapFontFamily } from '@tiptap/extension-font-family'
import { DEFAULT_FONT_FAMILY_MAP } from '@/constants/'
import type { GeneralOptions } from '@/notebook/type'
import FontFamilyButton from './components/FontFamilyMenuButton.vue'

export type FontFamilyOptions = {
  fontFamilyMap: {
    [key: string]: string
  }
} & TiptapFontFamilyOptions &
  GeneralOptions<FontFamilyOptions>
declare module '@tiptap/core' {
  type Commands<ReturnType> = {
    fontFamily: {
      /**
       * Set the text font family.
       * CSS font-size
       *
       */
      setFontFamily: (fontFamily: string) => ReturnType
      /**
       * Unset the font family
       */
      unsetFontFamily: () => ReturnType
    }
  }
}

export const FontFamily = TiptapFontFamily.extend<FontFamilyOptions>({
  name: 'fontFamily',
  addOptions() {
    return {
      ...this.parent?.(),
      types: ['textStyle'],
      fontFamilyMap: DEFAULT_FONT_FAMILY_MAP,
      button({ editor, extension, t }) {
        return {
          component: FontFamilyButton,
          componentProps: {
            editor,
            disabled: !editor.can().setFontFamily(''),
            tooltip: t('editor.fontFamily.tooltip'),
          },
        }
      },
    }
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element) => element.style.fontFamily.replace(/['"]/g, ''),
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) {
                return {}
              }

              return {
                style: `font-family: ${attributes.fontFamily}`,
              }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setFontFamily:
        (fontFamily) =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontFamily }).run()
        },
      unsetFontFamily:
        () =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontFamily: null }).removeEmptyTextStyle().run()
        },
    }
  },
})
